// Land is stored under several linked-table sub types (Brownfield 13, Greenfield 16),
// but the app treats them all as a single "Land" sub type keyed on 13: they share one
// asset class table, one set of forms and one map marker.
export const LAND_PROPERTY_SUB_TYPE_ID = 13
export const LAND_PROPERTY_SUB_TYPE_IDS = [13, 16]

/**
 * Maps a raw asset class type_id onto the sub type id the valuation process works with.
 * Use it whenever a screen switches on a target property's raw type_id.
 */
export function normalizePropertySubTypeId(typeId: number): number {
  return LAND_PROPERTY_SUB_TYPE_IDS.includes(typeId)
    ? LAND_PROPERTY_SUB_TYPE_ID
    : typeId
}
